
import * as React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Card } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { faLaptop } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';





export default function PercentDevicesPauseMode(props) {
    const { deviceStats, isLayoutChanged } = props
    const chartComponent = useRef({});
    const [noData, setNoData] = useState(false) 
    const [pausedPercentage, setPausedPercentage] = useState(0)

    const getPercentage = (deviceStats) => {
        return +(((deviceStats.maintenenceOn) / (deviceStats.deviceCount) * 100).toFixed(2))

    }
    const determineNoData = () => {
        if(deviceStats.maintenenceOn === 0 && deviceStats.maintenenceOff === 0){
         setNoData(true)
        }
     }
    useEffect(() => {
        determineNoData()
        if (deviceStats.maintenenceOn && deviceStats.deviceCount) {
            setPausedPercentage(getPercentage(deviceStats))
        }
    }, [deviceStats]);

    const pieChartData = [
        
        deviceStats.maintenenceOff !== 0 ?
        {
            name: "Off",
            y: deviceStats.maintenenceOff,
            color: 'rgb(232,143,0, 0.4)',
        } : '',
        deviceStats.maintenenceOn !== 0 ?
        {
            name: "On",
            y: deviceStats.maintenenceOn,
            color: 'rgb(50,205,50, 0.4)',
        } : '',
       ]

    const options = {
        chart: {

            type: 'pie',
        },
        legend: {
            align: 'left',
            verticalAlign: 'top',
            layout: 'vertical',
            x: 0,
            y: 100,
            labelFormatter: function () {
                if(this.y){
                    return 'Pause ' + this.name;
                }
                if(!this.y){
                    return 'No Values'
                }
            }
        },
        credits: {
            enabled: false
        },

        title: {
            text: noData ? 'No Data Available' : 'Devices In Pause Mode',
        },

        subtitle: {
            text: noData ? '' : `${deviceStats.maintenenceOn} Devices (${pausedPercentage}%) in Paused Mode`
        },

        tooltip: {
            pointFormat: ' {point.y} devices'
        },

        plotOptions: {
            pie: {
                borderRadius: 25,
                borderWidth: 5,
                dataLabels: {
                    enabled: true,
                    distance: '-30%',
                    format: '{point.y} {point.name}',

                },
                startAngle: -90,
                endAngle: 90,
                center: ['40%', '90%'],
                size: '135%',
                showInLegend: true
            }
        },
        
        series: [{
            name: "Total",
            innerSize: '50%',
            data: pieChartData,
        }],
    }

    useEffect(() => {
        const chart = chartComponent.current?.chart;
        if (chart) chart.reflow(false);
    }, [isLayoutChanged]);
    return (
        <Card sx={{ border: "solid 1px #ddd", height: '100%', padding: 1 }}>

            <FontAwesomeIcon
                icon={faLaptop}
                color={'rgb(232,143,0)'}
                size={'lg'}
                style={{ position: 'absolute', zIndex: 1 }}
            />
            <HighchartsReact
                ref={chartComponent}
                highcharts={Highcharts} options={options} containerProps={{ style: { height: "100%" } }} />
        </Card>

    );
}